/**
 * card-product.js
 * - Toggles the wishlist heart on product cards and remembers the
 *   choice in localStorage so it persists across page loads.
 * - Adds products to the cart via AJAX (fetch) WITHOUT ever
 *   submitting a real <form>, and WITHOUT opening any cart drawer /
 *   cart notification. Only the header cart count badge is updated.
 */
(function () {
  var STORAGE_KEY = 'wishlist_product_ids';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(ids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }

  function paintButton(button, isActive) {
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  }

  function initButtons() {
    var wishlist = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var id = button.getAttribute('data-product-id');
      paintButton(button, wishlist.indexOf(id) !== -1);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;

    event.preventDefault();
    var id = button.getAttribute('data-product-id');
    var wishlist = getWishlist();
    var index = wishlist.indexOf(id);

    if (index === -1) {
      wishlist.push(id);
    } else {
      wishlist.splice(index, 1);
    }

    saveWishlist(wishlist);
    paintButton(button, index === -1);
  });

  document.addEventListener('DOMContentLoaded', initButtons);
  if (document.readyState !== 'loading') initButtons();

  /* ------------------------------------------------------------------
     Add to Basket — AJAX only, no drawer.
     ------------------------------------------------------------------ */

  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setButtonText(button, text) {
    var label = button.querySelector('[data-add-to-cart-text]');
    if (label) {
      label.textContent = text;
    } else {
      button.textContent = text;
    }
  }

  function getButtonText(button) {
    var label = button.querySelector('[data-add-to-cart-text]');
    return (label ? label.textContent : button.textContent).trim();
  }

  function updateCartCountBadge(cart) {
    var count = cart && typeof cart.item_count !== 'undefined' ? Number(cart.item_count) : 0;

    /* Primary path: the ANC header exposes this helper and updates
       its #anc-cart-count span instantly. */
    if (typeof window.ancUpdateCartCount === 'function') {
      window.ancUpdateCartCount(cart);
    }

    /* Fallback path, in case a theme section still uses Shopify's
       standard "cart-icon-bubble" section name. Harmless no-op if
       that section doesn't exist on this theme. */
    fetch(routeRoot + '?sections=cart-icon-bubble', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (sections) {
        var html = sections && sections['cart-icon-bubble'];
        if (!html) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newBubble = doc.querySelector('#cart-icon-bubble') || doc.querySelector('.cart-count-bubble');
        var currentBubble = document.querySelector('#cart-icon-bubble') || document.querySelector('.cart-count-bubble');

        if (newBubble && currentBubble) {
          currentBubble.replaceWith(newBubble);
        }
      })
      .catch(function () {
        /* ignore — fall back to the manual selectors below */
      });

    var selectors = [
      '[data-cart-count]',
      '.anc-header__cart-count',
      '.cart-count-bubble .count',
      '.cart-count-bubble',
      '.cart-count',
      '.header__cart-count',
      '.basket-count',
      '.basket__count'
    ];

    document.querySelectorAll(selectors.join(',')).forEach(function (element) {
      var target = element.querySelector('.count') || element.querySelector('[data-cart-count]') || element;
      target.textContent = count;
      if (count > 0) {
        target.removeAttribute('hidden');
      } else {
        target.setAttribute('hidden', '');
      }
    });

    document.dispatchEvent(
      new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart, item_count: count } })
    );
  }

  function addToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.disabled) return;

    var originalText = getButtonText(button);
    button.disabled = true;
    button.classList.add('is-loading');
    setButtonText(button, 'Adding...');

    fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || 'Unable to add product to cart.');
          }
          return data;
        });
      })
      .then(function () {
        setButtonText(button, 'Added ✓');

        /* Only refresh the cart count — deliberately do NOT touch or
           open any cart-drawer / cart-notification element here. */
        return fetch(routeRoot + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(updateCartCountBadge);
      })
      .catch(function (error) {
        console.error('Add to cart error:', error);
        setButtonText(button, 'Try Again');
      })
      .finally(function () {
        setTimeout(function () {
          setButtonText(button, originalText);
          button.disabled = false;
          button.classList.remove('is-loading');
        }, 1200);
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-add-to-cart]');
    if (!button) return;

    event.preventDefault();
    addToCart(button);
  });
})();
